import * as angular from "angular";
import {IController, IFilterService, IPromise, IQService, ITimeoutService, IScope, IWindowService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {BranchesDialogService} from "../../../branches/services/branches-dialogs-service.service";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {RouteRequestsService} from "../../services/routes-requests.service";
import {RoutesService} from "../../services/routes-service.service";
import {
  LeanPlanningAlertsService
} from "../../../lean-planning/services/lean-planning-alerts.factory";
import {
  LeanPlanningDialogService
} from "../../../lean-planning/services/lean-planning-dialogs-service.factory";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";
import {LeanPlanningRequestsService} from "../../../lean-planning/services/plan-requests.factory";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ResizerService} from "../../../commons/services/resizer.service";
import {
  DateRangeTimeFiltersService
} from "../../../commons/services/date-range-time-filters.service";
import {TasksFacadeService} from "../../../tasks/angular/services/tasks-facade.service";
import {Subscription} from "rxjs";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {ServiceAreaRequests} from "../../../service-areas/services/service-area-requests.service";
import {RoutesFacadeService} from "../../../lean-planning/angular/services/routes-facade.service";
import {RouteModel} from "../../models/route.model";
import {BreadcrumbsService} from "../../../commons/angular/services/breadcrumbs.service";
import {RoutePanelModel} from "../../models/route-panel.model";
import {RoutesViewMode} from "../../enums/routes-view-mode.enum";
import {MIN_PANEL_SIZE, MIN_PANEL_WIDTH, MAX_DOCKED_PANEL} from "../../../commons/angular/constants/commons";
import {
  ViewSettingsHolderType,
  ViewSettingsModel,
  ViewSettingsType
} from "../../../commons/models/view-settings.model";
import {
  RoutesPanelsSettingsModel,
  RoutesViewSettingsModel
} from "../../models/routes-view-settings.model";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {
  EditDispatchRouteNamePanelService
} from "../../services/edit-dispatch-route-name-panel.service";
import {
  EditDispatchedRouteNameRequestModel
} from "../../models/edit-dispatched-route-name-request.model";
import {TaskModel} from "../../../tasks/models/task.model";
import {RouteExportRowType} from "../../enums/route-export-row.type";
import {DeliveriesDialogService} from "../../../deliveries/services/deliveries-dialog-service.service";
import {ServicesService} from "../../../deliveries/services/services-service.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {
  ResourceAllocationTimeWindowExtModel
} from "../../../resources/models/resource-allocation-time-window-ext.model";
import {PanelService} from "../../../commons/angular/services/panel.service";
import {Service} from "../../../deliveries/models/service.model";
import {
  ServiceSplitByPackagesComponent,
  SplitAssignmentType
} from "../../angular/components/service-split-by-packages/service-split-by-packages.component";
import {
  ServicesMovePackagesResponseModel,
  SplitServicesPayloadModel
} from "../../../deliveries/models/services-move-packages-payload.model";
import {DeliveriesAlertsService} from "../../../deliveries/services/deliveries-alerts.service";
import {ChangeRouteResourceQueryModelModel} from "../../models/change-route-resource-query-model.model";
import {GetRouteIdsByQueryPayloadModel} from "../../models/get-route-ids-by-query-payload.model";

export class RoutesViewComponent implements IController {

  viewSettings?: ViewSettingsModel;
  project?: any;
  branchMode?: any;
  onSelectRouteResource: Function;


  public siteId: any;
  public timelineZoom: any = undefined;
  public routesMenu: any = {
    deleteEnabled: true,
    resetEnabled: true
  };
  public expandedRoutes: any = [];
  public expandedRoutesTasks: any = []
  public suggestedServices: any = [];
  public selectedServiceIds: string[] = [];
  public routeGroupKeys: any;
  public expendedRoutesServiceAreas: any = [];
  public isMouseHorizontalDown: boolean = false;
  public isMouseVerticalDown: boolean = false;
  public showMap: boolean = true;
  public isMobile: boolean;
  public flexLeft: any;
  public flexRight: any;
  public selectedTaskId: any;
  public timeSelectEnabled: any;
  public pushesTimeoutRef: any;
  public maxUserIdleTimeMinutes: number;
  public pageName: string;
  public routesSubscription: Subscription;
  public sortTypesValues: any;
  public selectedSortValue: any;
  public routes: RouteModel[];
  public isLoadingRoutes: boolean;
  public loading: boolean;
  public panelsRouteIdsSubscription: Subscription;

  public panels: RoutePanelModel[] = [];
  public showPanels: boolean = true;
  private generalSettings: RoutesViewSettingsModel;
  private panelRouteIdsMap: any = {};
  public isStillThereConfirmEnabled: boolean = false;
  public resourcesDropListIds: string[] = [];
  public routesDropListIds: string[] = [];
  private _splitPackagesPopupSubscription: Subscription | null = null;
  public ungroupedRouteIds: Set<string> = new Set<string>();
  public activePanelId: string = '';

  public RoutesViewMode = RoutesViewMode;
  public viewMode: RoutesViewMode = RoutesViewMode.CARDS;
  public isResizingTableMode: boolean = false;
  public tablePanelsWidth: number = 600;
  private tableMouseMoveListener: any;
  private tableMouseUpListener: any;
  private resizeHandlerBound: any;
  private viewSettingsCreation: IPromise<void> | null = null;
  private hasPendingViewSettingsUpdate: boolean = false;

  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $state, private routesService: RoutesService, private leanPlanningRequestsService: LeanPlanningRequestsService, private routeRequestsService: RouteRequestsService,
              private splitService: SplitService, private TimelineService, private commonsDialogService: CommonsDialogService, private resizerService: ResizerService, private routesConstants,
              private $timeout: ITimeoutService, private tasksService: TasksService, private commonsService: CommonsService, private $groups, private routesFacadeService: RoutesFacadeService,
              private leanPlanningConstants, private moment, private branchesDialogService: BranchesDialogService, private leanPlanningAlertsService: LeanPlanningAlertsService, private bringozLoaderService: BringozLoaderService,
              private $log, private confirmDialogService: ConfirmDialogService, private leanPlanningDialogService: LeanPlanningDialogService, private $serviceArea, private $task, private $mdMedia,
              private $route, private leanPlanningService: LeanPlanningService, private commonsConstants, private $delivery, private deliveriesService: DeliveriesService, private breadcrumbsService: BreadcrumbsService,
              private tasksFacadeService: TasksFacadeService, private viewFilterSettingsService: ViewFilterSettingsService, private $filter, private $q: IQService,
              private serviceAreaRequests: ServiceAreaRequests, private viewSettingsService: ViewSettingsService, private resizeService: ResizeService, private servicesService: ServicesService,
              private editDispatchRouteNamePanelService: EditDispatchRouteNamePanelService, private deliveriesDialogService: DeliveriesDialogService, private panelService: PanelService,
              private deliveriesAlertsService: DeliveriesAlertsService, private $window: IWindowService, private $scope: IScope) {
    this.siteId = this.splitService.getSiteId();
    this.routeGroupKeys = this.leanPlanningConstants.routeGroupKeys;
    this.maxUserIdleTimeMinutes = this.splitService.maxUserIdleTimeMinutes();

    this.resizeHandlerBound = () => {
      this.constrainTablePanelsWidth();
      this.$timeout(() => {});
    };
    angular.element(this.$window).on('resize', this.resizeHandlerBound);
  }

  $onInit() {
    this.sortTypesValues = {
      sortNotBefore: {asc: 'notBefore,asc', desc: 'notBefore,desc'},
      sortLogisticVehiclePlateNumber: {
        asc: 'planningResource.mainLogisticsVehicleReference.licensePlateNumber,asc',
        desc: 'planningResource.mainLogisticsVehicleReference.licensePlateNumber,desc'
      },
    };

    if (!this.viewSettings) {
      this.viewSettings = {
        pageName: 'routes',
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.ViewTable,
      };
    }

    if (!this.viewSettings.settings) {
      this.viewSettings.settings = {
        panels: [],
        viewSettings: this._getDefaultViewSettings()
      };
    } else {
      this.panels = !this.viewSettings.settings.panels ? [] :
        angular.copy(this.viewSettings.settings.panels);

      const hasDefaultChanged = this._getHasDefaultViewSettingsChanged(this.viewSettings.settings);
      if (!!hasDefaultChanged || !this.viewSettings.settings.viewSettings) {
        this.viewSettings.settings.viewSettings = this._getDefaultViewSettings();
      }

      if (this.viewSettings.settings?.viewMode) {
        this.viewMode = this.viewSettings.settings.viewMode;
      }

      if (this.viewSettings.settings?.tablePanelsWidth) {
        this.tablePanelsWidth = this.viewSettings.settings.tablePanelsWidth;
      }
      this.constrainTablePanelsWidth();
    }

    if (!this.panels?.length) {
      const panel: RoutePanelModel = {
        id: this.moment().valueOf().toString(),
        selectedTabIndex: 0,
        selectedRouteId: undefined,
        routesFilters: {},
        servicesFilters: {}
      };
      this.panels = [panel];
      this.viewSettings.settings.panels = angular.copy(this.panels);
      this.showPanels = true;
    }

    this.isMouseHorizontalDown = false;
    this.isMouseVerticalDown = false;

    this.breadcrumbsService.off();

    this.routesFacadeService.subscribeToChannels();

    // Routes Subscription
    this.routesSubscription = this.routesFacadeService.selectAll()
      .subscribe((routes: RouteModel[]) => {
        this.expandedRoutes = routes;
        this.$timeout(0).then(() => {
        });
      })

    // Panels Routes Subscription
    this.panelsRouteIdsSubscription = this.routesFacadeService.getPanelsRouteIdsMap()
      .subscribe((panelRouteIdsMap: any) => {
        this.panelRouteIdsMap = panelRouteIdsMap;

        let allPanelsRouteIds = [];
        _.forOwn(panelRouteIdsMap, (value, key) => {
          allPanelsRouteIds = _.uniq(_.concat(allPanelsRouteIds, value));
        })
        const expandedRouteIdsToRemove = _.difference(_.map(this.expandedRoutes, 'id'), allPanelsRouteIds);

        if (expandedRouteIdsToRemove?.length) {
          this._removeExpandedRoutes(expandedRouteIdsToRemove);
        }

        // Update Angularjs Cycle
        this.$timeout(0).then(() => {
        });
      })

    // Bind User Event Listeners
    this.commonsService.bindUserEvents((event) => {
      if (!!this.pushesTimeoutRef) {
        this._initPushesTimer();
      }
    })

    this._initPushesTimer();
  };

  $doCheck() {
    this.isMobile = !this.$mdMedia('gt-xs');
    this.flexLeft = this.$mdMedia('gt-sm') ? '65%' : '100%';
    this.flexRight = this.$mdMedia('gt-sm') ? '35%' : '100%';
  };

  $onDestroy() {
    if (this.tableMouseMoveListener) {
      this.$window.removeEventListener('mousemove', this.tableMouseMoveListener);
    }
    if (this.tableMouseUpListener) {
      this.$window.removeEventListener('mouseup', this.tableMouseUpListener);
    }
    if (this.resizeHandlerBound) {
      angular.element(this.$window).off('resize', this.resizeHandlerBound);
    }
    if (this.routesSubscription) {
      this.routesSubscription.unsubscribe();
    }
    if (this.panelsRouteIdsSubscription) {
      this.panelsRouteIdsSubscription.unsubscribe();
    }
    if (this._splitPackagesPopupSubscription) {
      this._splitPackagesPopupSubscription.unsubscribe();
    }

    this.routesFacadeService.clearStore();
    this.breadcrumbsService.on();
    this._destroyPushesTimer();
  }

  onAddPanel(tabIndex?, routeId?, routedServices?) {
    const lastPanel = this.panels?.length ? _.last(this.panels) : undefined;
    const panel: RoutePanelModel = {
      id: this.moment().valueOf().toString(),
      selectedTabIndex: tabIndex || 0,
      selectedRouteId: routeId,
      routesFilters: lastPanel ? angular.copy(lastPanel.routesFilters) : {},
      servicesFilters: lastPanel ? angular.copy(lastPanel.servicesFilters) : {},
      resourcesFilters: lastPanel ? angular.copy(lastPanel.resourcesFilters) : {}
    };

    if (!panel.servicesFilters.bringozFilters) {
      panel.servicesFilters.bringozFilters = {};
    }
    panel.servicesFilters.bringozFilters[SiteFiltersType.inRoute] = routedServices;

    const dockedPanelsCount = _.filter(this.panels, (p) => !p.isFloating).length;
    if (dockedPanelsCount >= MAX_DOCKED_PANEL) {
      panel.isFloating = true;
    }

    this.panels.push(panel);

    this.viewSettings.settings.panels = this.panels;
    this.constrainTablePanelsWidth();
    this.updateViewSettings(this.viewSettings.settings);
  }

  private _getPanelIndex(indexOrId: any, panels: any[]): number {
    if (typeof indexOrId === 'number') {
      return indexOrId;
    }
    return _.findIndex(panels, { id: indexOrId });
  }

  onDrillDown(routeId: string, index: number, event: any) {
    const nextIndex = index + 1;
    const nextPanel = this.panels[nextIndex];

    const isFloating = event && event.type === 'dblclick';

    if (isFloating) {
      this.onAddPanel(0, routeId);
      const newPanel = _.last(this.panels);
      newPanel.isFloating = true;
      this.activePanelId = newPanel.id;
      this.viewSettings.settings.panels = this.panels;
      this.updateViewSettings(this.viewSettings.settings);
    } else if (nextPanel) {
      this.panels[nextIndex].selectedTabIndex = 0;
      this.panels[nextIndex].selectedRouteId = routeId;
      this.viewSettings.settings.panels = this.panels;
      this.updateViewSettings(this.viewSettings.settings);
    } else {
      this.onAddPanel(0, routeId);
    }
  }

  getPanelTitle(panel: RoutePanelModel, indexOrId: any): string {
    const index = this._getPanelIndex(indexOrId, this.panels);
    return 'Panel ' + (index > -1 ? index + 1 : 1);
  }

  getFloatingPanelData(panel: RoutePanelModel, indexOrId: any): any {
    if (!panel.floatingPanelData) {
      const index = this._getPanelIndex(indexOrId, this.panels);
      const safeIndex = index > -1 ? index : 0;
      panel.floatingPanelData = {
        position: { x: 80 + safeIndex * 40, y: 80 + safeIndex * 40 },
        size: MIN_PANEL_SIZE
      };
    }
    return panel.floatingPanelData;
  }

  onFloatingPanelDataChange(event: any, indexOrId: any): void {
    const index = this._getPanelIndex(indexOrId, this.panels);
    if (index > -1 && this.panels[index]) {
      this.panels[index].floatingPanelData = event;
      this.viewSettings.settings.panels = this.panels;
      this.updateViewSettings(this.viewSettings.settings);
    }
  }

  onFloatingPanelIsMinimizedChange(isMinimized: boolean, indexOrId: any): void {
    const index = this._getPanelIndex(indexOrId, this.panels);
    if (index > -1 && this.panels[index]) {
      this.panels[index].isMinimized = isMinimized;
      this.viewSettings.settings.panels = this.panels;
      this.updateViewSettings(this.viewSettings.settings);
    }
  }

  onPanelClick(id: string): void {
    this.activePanelId = id;
  }

  onToggleFloatPanel(indexOrId: any, isFloating?: boolean): void {
    const index = this._getPanelIndex(indexOrId, this.panels);
    if (index > -1 && this.panels[index]) {
      const isNowFloating = isFloating !== undefined ? isFloating : !this.panels[index].isFloating;
      this.panels[index].isFloating = isNowFloating;
      if (isNowFloating) {
        this.activePanelId = this.panels[index].id;
      }
      this.viewSettings.settings.panels = this.panels;
      this.constrainTablePanelsWidth();
      this.updateViewSettings(this.viewSettings.settings);
    }
  }

  onChangeRouteInfo(route, event) {
    const routeName = route.name;
    const pickingTimeOffsetInMinutes = route?.pickingTimeOffsetInMinutes

    this.editDispatchRouteNamePanelService.open(event, route, routeName, pickingTimeOffsetInMinutes,
      (updatedRouteName: string, updatedPickingTimeOffsetInMinutes?: number) => {
        let routeId = route.id;

        if (!!updatedRouteName && routeName !== updatedRouteName) {
          this._updateRouteName(routeId, updatedRouteName);
        }

        if (!_.isUndefined(updatedPickingTimeOffsetInMinutes) && (pickingTimeOffsetInMinutes !== updatedPickingTimeOffsetInMinutes)) {
          const routeCopy = angular.copy(route);
          routeCopy.pickingTimeOffsetInMinutes = updatedPickingTimeOffsetInMinutes;

          this._updateRoute(routeCopy);
        }

      },
      (metaDataPayload) => {
        return this._updateRouteMetaData(route.id, metaDataPayload, route);
      })
  }

  onClosePanel(indexOrId) {
    const index = this._getPanelIndex(indexOrId, this.panels);
    if (index === -1) return;

    const panelId = this.panels[index]?.id;

    if (!!panelId) {
      this.routesFacadeService.removePanelRouteIds(panelId);
    }

    this.panels.splice(index, 1);

    if (!this.panels.length) {
      this.showMap = true;
      this.expandedRoutes = [];
      this.expandedRoutesTasks = [];
    }

    this.viewSettings.settings.panels = this.panels;
    this.constrainTablePanelsWidth();
    this.updateViewSettings(this.viewSettings.settings);
  }

  onToggleShowMap() {
    this.showMap = !this.showMap
    this.resizeService.resize();
  }

  onPanelChange(panel, indexOrId) {
    const index = this._getPanelIndex(indexOrId !== undefined ? indexOrId : panel.id, this.panels);
    if (index > -1) {
      this.panels[index] = panel;
      this.viewSettings.settings.panels = this.panels;
      this.updateViewSettings(this.viewSettings.settings);
    }
  }


  onDividerMove(event) {
    if (this.isMouseHorizontalDown) {
      this.resizerService.onHorizontalMove(event)
        .then((flex) => {
          this.flexLeft = flex.left;
          this.flexRight = flex.right;
        });
    }
  }

  onDividerMoveDone() {
    this.isMouseHorizontalDown = false;
    this.isMouseVerticalDown = false;
  }

  onResetRoute(panel, routeId) {
    this.confirmDialogService.confirm('Reset Route', 'Are you sure you want to reset?')
      .then(() => {
        this._resetRoutes(panel, [routeId], false);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onResetRoutes(panel: RoutePanelModel, ids, excludeMode) {
    this.confirmDialogService.confirm('Reset Routes', 'Are you sure you want to reset?')
      .then(() => {
        this._resetRoutes(panel, ids, excludeMode);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onTimelineZoom(isZoomIn) {
    this.timelineZoom = isZoomIn;
  }

  onZoomChanged() {
    this.timelineZoom = undefined;
  }

  // onMoveTask(serviceId: string, fromRouteId: string, toRouteId: string, fromOrderedIds: string[], toOrderedIds: string[], isBetweenDays?: boolean, toDate?: string) {
  //   const functionRef = isBetweenDays ? this.deliveriesDialogService.editServiceTimeWindow(serviceId, toDate) : this.$q.when();
  //
  //   functionRef
  //     .then((serviceTimePayload) => {
  //       const dateEdit = {
  //         type: 'ChangeNotBeforeNotAfter',
  //         notBefore: _.get(serviceTimePayload, 'service.notBefore'),
  //         notAfter: _.get(serviceTimePayload, 'service.notAfter')
  //       }
  //       return !!_.get(serviceTimePayload, 'service') ? this.servicesService.updateBulk([serviceId], {dateEdit}, serviceTimePayload.isShouldSendSms) : this.$q.when();
  //     })
  //     .then(() => {
  //       const payload = this.TimelineService.getMovedTaskPayload([serviceId], fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);
  //       this.loading = true;
  //       this.leanPlanningRequestsService.editRoutes(payload)
  //         .then((updatedRoutes) => {
  //           this.leanPlanningAlertsService.updateSuccess();
  //         })
  //         .catch((error) => {
  //           if (error) {
  //             this.leanPlanningAlertsService.updateError();
  //             this.$log.error(
  //               'Failed to change route itinerary @planningRoute@onRouteOrderChange',
  //               error);
  //           }
  //         })
  //         .finally(() => {
  //           this.loading = false;
  //         })
  //     })
  // }

  onReoptimizeRoute(routeId) {
    this.loading = true;
    this.leanPlanningRequestsService.optimizeRoute(routeId)
      .then((optimizedRoute) => {
        //Updating From Push
        this.leanPlanningAlertsService.reOptimizeSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.reOptimizeError();
          this.$log.error('Failed to Optimize route @planningRoute@onRecalcRoute', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onMergeRoutes(panel: RoutePanelModel, ids, excludeMode) {
    this.confirmDialogService.confirm('Merge Routes', 'Are you sure you want to merge these routes?')
      .then(() => {
        this.loading = true;
        return this.routeRequestsService.mergeRoutes(
          excludeMode ? [] : ids,
          panel.routesFilters.bringozFilters.branchIds,
          excludeMode ? ids : [],
          panel.routesFilters.range.dateStart,
          panel.routesFilters.range.dateEnd,
          panel.routesFilters.bringozFilters.agentSkills,
          panel.routesFilters.queryString,
          panel.routesFilters.bringozFilters.serviceAreaIds,
          (panel.routesFilters.routesStatus ? [panel.routesFilters.routesStatus] : undefined),
          panel.routesFilters.bringozFilters.resourceIds.concat(panel.routesFilters.bringozFilters.agentScheduleIds),
          panel.routesFilters.bringozFilters.tags,
          panel.routesFilters.bringozFilters.depotIds,
          panel.routesFilters.bringozFilters.resourceTags,
          panel.routesFilters.bringozFilters.vehicleTypeIds,
          panel.routesFilters.bringozFilters.relationTypes
        )
      })
      .then(() => {
        this.leanPlanningAlertsService.mergeRoutesSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.mergeRoutesError();
          this.$log.error('Failed to merge routes @planningRoutes@onMergeRoutes', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  // onDeleteRoute(routeId, event) {
  //   this.confirmDialogService.confirm('Delete Route', 'Are you sure you want to delete this route?', event)
  //     .then(() => {
  //       panel, ids, excludeMode
  //       this._deleteRoutes([routeId], false);
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed');
  //     })
  // }

  onDeleteRoutes(panel: RoutePanelModel, ids, excludeMode?) {
    this.confirmDialogService.confirm('Delete Routes', 'Are you sure you want to delete these routes?')
      .then(() => {
        this._deleteRoutes(panel, ids, excludeMode);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onUpdateBranchesRoutes(panel: RoutePanelModel, ids, excludeMode, $event) {
    this.branchesDialogService.branchesSelect(event)
      .then((branchIds) => {
        this._updateBranchesRoutes(panel, ids, excludeMode, branchIds);
      })
  }

  onUpdateBranches(id: string, branchIds: string[]) {
    this.branchesDialogService.branchesSelect(event, undefined, branchIds)
      .then((branchIds) => {
        this._updateBranchesRoute(id, branchIds);
      })
  }

  onTaskSelection(taskId) {
    this.selectedTaskId = taskId;
  }

  onSelectServices(ids: string[]) {
    this.selectedServiceIds = ids;
  }

  onToggleVisibleRoute(route: RouteModel, isVisible: boolean) {
    const mapRouteIndex = _.findIndex(this.expandedRoutes, (expendedRoute: any) => {
      return expendedRoute.rid === route.rid;
    })
    if (mapRouteIndex === -1) {
      this._setExpandedRoutes([route]);
    } else {
      this._removeExpandedRoutes([route.id]);
    }
  }

  onUpdateIsBlockedByUser(routeId, isBlockedByUser) {
    this.leanPlanningService.editBlockedState(routeId, isBlockedByUser)
      .then((updatedRoute: any) => {
        const expandedRouteIndex = _.findIndex(this.expandedRoutes, (r: any) => {
          return r.id === updatedRoute.id;
        })
        if (expandedRouteIndex > -1) {
          const expandedRoutesCopy = angular.copy(this.expandedRoutes);
          expandedRoutesCopy[expandedRouteIndex] = updatedRoute;

          this.expandedRoutes = expandedRoutesCopy;
        }
        this.resetSelection();
      })
  }

  resetSelection(ids?: string[]) {
    if (ids) {
      this.expandedRoutes = _.filter(this.expandedRoutes, (route) => {
        return !_.includes(ids, route.rid);
      });
    }

    this.expendedRoutesServiceAreas = ids ? _.filter(this.expendedRoutesServiceAreas, (serviceArea) => {
      const connectedRoute = _.find(this.expandedRoutes, (r) => {
        const areaIdList = _.get(r, 'serviceAreaIdList', []);
        return _.includes(areaIdList, serviceArea.areaId)
      })
      return !!connectedRoute;
    }) : [];
    this.selectedTaskId = undefined;
    this.selectedServiceIds = [];
  }

  onExport(type: RouteExportRowType, panel: RoutePanelModel, ids?: string[], excludeMode?: boolean) {
    this.routesService.exportRoutes(
      excludeMode ? [] : ids,
      excludeMode ? ids : [],
      panel.routesFilters.bringozFilters.branchIds,
      panel.routesFilters.bringozFilters.serviceAreaIds,
      (panel.routesFilters.routesStatus ? [panel.routesFilters.routesStatus] : undefined),
      panel.routesFilters.range.dateStart,
      panel.routesFilters.range.dateEnd,
      panel.routesFilters.queryString,
      panel.routesFilters.bringozFilters.agentSkills,
      type,
      panel.routesFilters.bringozFilters.tags,
      panel.routesFilters.bringozFilters.resourceIds,
      panel.routesFilters.bringozFilters.depotIds,
      panel.routesFilters.bringozFilters.resourceTags,
      panel.routesFilters.bringozFilters.vehicleTypeIds,
      panel.routesFilters.bringozFilters.relationTypes
    )
      .then((res) => {
        this.resetSelection();
      });
  }

  onExportIntegration(ids: string[]) {
    this.routesService.exportIntegrationRoutes(ids)
      .then((res) => {
        this.resetSelection();
      });
  }


  onUpdateResource(route: RouteModel) {
    this.leanPlanningDialogService.updateResource(route, true)
      .then((payload: {
        allocation: ResourceAllocationTimeWindowExtModel,
        queries: ChangeRouteResourceQueryModelModel
      }) => {
        this._updateRouteResource(route.id, payload.allocation, payload.queries);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  onManageAssistants(route: RouteModel, event?) {
    this.leanPlanningDialogService.manageAssistants(route, event)
      .then((updatedAssistants: string[]) => {
        this._assignAssistant(route.id, updatedAssistants)
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  onUpdateLogisticsVehicle(route: RouteModel, task, event) {
    this.leanPlanningDialogService.onUpdateRouteBoundEquipment(route, _.get(route, 'branchIds'), event)
      .then((payload) => {
        const routeCopy = angular.copy(route);
        routeCopy.planningResource.mainLogisticsVehicleReference = payload.mainLogisticVehicle;
        if (payload.attachedLogisticVehicle) {
          if (!routeCopy.planningResource.attachedLogisticsVehicleReferences) {
            routeCopy.planningResource.attachedLogisticsVehicleReferences = [];
          }
          routeCopy.planningResource.attachedLogisticsVehicleReferences[0] = payload.attachedLogisticVehicle;
        }
        this._updateRoute(routeCopy);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  onChangeRouteColor(route: RouteModel) {
    this.commonsDialogService.selectColor(route.color, this.commonsConstants.colorPalletRoutes)
      .then((selectedColor) => {
        const updatedRoute = angular.copy(route);
        updatedRoute.color = selectedColor;
        this._updateRoute(updatedRoute);
      })
  }

  onViewSettingsChange(viewSettings: RoutesViewSettingsModel) {
    this.viewSettings.settings.viewSettings = viewSettings;
    this.updateViewSettings(this.viewSettings.settings);
  }

  onToggleViewMode(mode: RoutesViewMode) {
    this.viewMode = mode;
    this.viewSettings.settings.viewMode = mode;
    this.constrainTablePanelsWidth();
    this.updateViewSettings(this.viewSettings.settings);
    this.resizeService.resize();
  }

  constrainTablePanelsWidth() {
    const dockedPanelsCount = this.panels ? this.panels.filter(p => !p.isFloating).length : 0;
    const minWidth = MIN_PANEL_WIDTH * (dockedPanelsCount || 1);
    const maxWidth = Math.max(minWidth, this.$window.innerWidth - 100);

    if (this.tablePanelsWidth < minWidth) {
      this.tablePanelsWidth = minWidth;
    }
    if (this.tablePanelsWidth > maxWidth) {
      this.tablePanelsWidth = maxWidth;
    }
    if (this.viewSettings?.settings) {
      this.viewSettings.settings.tablePanelsWidth = this.tablePanelsWidth;
    }
  }

  onTableResizerMouseDown(event: MouseEvent) {
    this.isResizingTableMode = true;
    event.preventDefault();

    this.tableMouseMoveListener = this.onTableResizerMouseMove.bind(this);
    this.tableMouseUpListener = this.onTableResizerMouseUp.bind(this);

    this.$window.addEventListener('mousemove', this.tableMouseMoveListener);
    this.$window.addEventListener('mouseup', this.tableMouseUpListener);
  }

  onTableResizerMouseMove(event: MouseEvent) {
    if (this.isResizingTableMode) {
      const dockedPanelsCount = this.panels ? this.panels.filter(p => !p.isFloating).length : 0;
      const minWidth = MIN_PANEL_WIDTH * (dockedPanelsCount || 1);

      this.tablePanelsWidth = Math.max(minWidth, Math.min(event.clientX, this.$window.innerWidth - 10));
      this.$scope.$apply();
    }
  }

  onTableResizerMouseUp() {
    this.isResizingTableMode = false;
    this.$window.removeEventListener('mousemove', this.tableMouseMoveListener);
    this.$window.removeEventListener('mouseup', this.tableMouseUpListener);
    this.viewSettings.settings.tablePanelsWidth = this.tablePanelsWidth;
    this.updateViewSettings(this.viewSettings.settings);
    this.resizeService.resize();
    this.$scope.$apply();
  }

  onRouteReset(route) {
    this.leanPlanningDialogService.routeReset(route)
      .then((payload) => {
        this.loading = true;
        return this.routeRequestsService.resetRoutes(route.rid, undefined, undefined, undefined, undefined, payload.resetOnlyAssignAgentServices);
      })
      .then(() => {
        this.leanPlanningAlertsService.resetSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.resetError();
          this.$log.error('Failed to reset route', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onRouteResourcesAssignment(panel: RoutePanelModel, ids?: string[], excludeMode?: boolean, step: 'agent-assign' | 'agent-associate' | 'assistant' | 'vehicle' = 'agent-assign', route?: RouteModel) {
    let queries: GetRouteIdsByQueryPayloadModel;
    if (!!excludeMode) {
      queries = {
        branchIds: panel.routesFilters.bringozFilters.branchIds,
        areaIds: panel.routesFilters.bringozFilters.serviceAreaIds,
        resourceIds: panel.routesFilters.bringozFilters.resourceIds,
        excludeIds: excludeMode ? ids : [],
        skill: panel.routesFilters.bringozFilters.agentSkills,
        status: (panel.routesFilters.routesStatus ? [panel.routesFilters.routesStatus] : undefined),
        from: panel.routesFilters.range.dateStart,
        to: panel.routesFilters.range.dateEnd,
        tags: panel.routesFilters.bringozFilters.tags,
        resourceTags: panel.routesFilters.bringozFilters.resourceTags,
        vehicleTypeIds: panel.routesFilters.bringozFilters.vehicleTypeIds,
        relationTypes: panel.routesFilters.bringozFilters.relationTypes,
        query: panel.routesFilters.queryString,
        depotIds: panel.routesFilters.bringozFilters.depotIds,
        limit: 1000
      }
      // supplyResourceSource?: string;
    }
    const functionRef = !!excludeMode ? this.routesService.getRouteIdsByQuery(queries) : this.$q.when(ids)
    functionRef
      .then((routeIds: string[]) => {
        this.leanPlanningDialogService.routeResourcesAssigment(routeIds, step, route);
      });
  }

  onAssignAndSelect(ids: string[], ev?) {
    this.leanPlanningDialogService.manualAssignRoutes(ev, ids)
      .then((payload) => {
        this._assignRoutes(ids, payload.agentId, payload.assignServices);
      })
  }

  onAssociate(ids: string[], ev?) {
    this.leanPlanningDialogService.manualAssignRoutes(ev, ids, true)
      .then((payload) => {
        this.routesService.associateAgent(ids, payload.agentId, payload.branchIds);
      });
  }

  onAssignToAttachedAgent(panel: RoutePanelModel, ids, excludeMode) {
    this.routeRequestsService.assignRoutesToAttachedAgents(
      excludeMode ? [] : ids,
      panel.routesFilters.bringozFilters.branchIds,
      excludeMode ? ids : [],
      panel.routesFilters.range.dateStart,
      panel.routesFilters.range.dateEnd,
      panel.routesFilters.bringozFilters.agentSkills,
      panel.routesFilters.queryString,
      panel.routesFilters.bringozFilters.serviceAreaIds,
      (panel.routesFilters.routesStatus ? [panel.routesFilters.routesStatus] : undefined),
      panel.routesFilters.bringozFilters.resourceIds.concat(panel.routesFilters.bringozFilters.agentScheduleIds),
      panel.routesFilters.bringozFilters.tags,
      panel.routesFilters.bringozFilters.depotIds,
      panel.routesFilters.bringozFilters.resourceTags,
      panel.routesFilters.bringozFilters.vehicleTypeIds,
      panel.routesFilters.bringozFilters.relationTypes
    )
      .then(() => {
        this.leanPlanningAlertsService.assignSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        this.leanPlanningAlertsService.assignError();
        // this.$log.error('Failed to assign route to driver @planningRoutesTable@onAssignRoute', error)
      })
      .finally(() => {
        // this.loading = false;
        this.resetSelection();
      })
  }

  OnHandleUnpackedServices(route: RouteModel) {
    this.$delivery.$asyncValues(route.serviceIdList)
      .then((services) => {
        let unpackedDeliveries = [];
        _.forEach(services, (service) => {
          var isUnpacked = this.deliveriesService.isDeliveryUnpacked(service.packageList[0].items);
          if (isUnpacked) {
            unpackedDeliveries.push(service);
          }
        });
        this._handleUnpackedServices(route, unpackedDeliveries)
      })
  }

  onUpdateLogisticsVehicleRoute(route) {
    this.leanPlanningDialogService.onUpdateRouteBoundEquipment(route, route.branchIds, event)
      .then((payload) => {
        const routeCopy = angular.copy(route);
        if (payload.mainLogisticVehicle) {
          routeCopy.planningResource.mainLogisticsVehicleReference = payload.mainLogisticVehicle;
        }
        if (payload.attachedLogisticVehicle) {
          if (!routeCopy.planningResource.attachedLogisticsVehicleReferences) {
            routeCopy.planningResource.attachedLogisticsVehicleReferences = [];
          }
          routeCopy.planningResource.attachedLogisticsVehicleReferences[0] = payload.attachedLogisticVehicle;
        }
        this._updateRoute(routeCopy);
        // this._updateInternalTask(task)
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  // onPrint(routeId) {
  //   this.routesService.printRoutes([routeId]);
  // }

  // onPrintLoadingSheet(routeId) {
  //   this.routesService.printLoadingSheet([routeId]);
  // }

  // onPrintBillOfLading(routeId) {
  //   this.routesService.onPrintBOL([routeId]);
  // }

  // onDownloadBillOfLading(routeId) {
  //   this.routesService.onDownloadBOL([routeId]);
  // }

  onPrintIkea(route) {
    const serviceIds = _.uniq(route.routeTaskList.filter(t => t.taskType === 'Stopover').map(t => t.serviceId));
    this.$delivery.$asyncValues(serviceIds)
      .then((services) => {
        this.commonsDialogService.printIkea(services);
      })
  }

  onEditRoutes(serviceId: string | string[], fromRouteId: string, toRouteId: string, fromOrderedIds: string[], toOrderedIds: string[], isBetweenDays?: boolean, toDate?: string) {
    const isMulti = _.isArray(serviceId) && serviceId.length > 1;
    const functionRef = isBetweenDays ? this.deliveriesDialogService.editServiceTimeWindow(isMulti ? serviceId[0] : serviceId, toDate) : this.$q.when();

    functionRef
      .then((serviceTimePayload) => {
        const dateEdit = {
          type: 'ChangeNotBeforeNotAfter',
          notBefore: _.get(serviceTimePayload, 'service.notBefore'),
          notAfter: _.get(serviceTimePayload, 'service.notAfter')
        }
        const flatServiceIds = _.isArray(serviceId) ? serviceId : [serviceId];
        return !!_.get(serviceTimePayload, 'service') ? this.servicesService.updateBulk(flatServiceIds, {dateEdit}, serviceTimePayload.isShouldSendSms) : this.$q.when();
      })
      .then(() => {
        const serviceIds = _.isArray(serviceId) ? serviceId : [serviceId];
        this._editRoutes(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);
      })
  }

  private _editRoutes(serviceIds: string[], fromRouteId: string, toRouteId: string, fromOrderedIds: string[], toOrderedIds: string[]) {
    const payload = this.TimelineService.getMovedTaskPayload(serviceIds,
      fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);

    this.loading = true;
    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.editRoutes(payload, true)
      .then((updatedRoutes) => {
        //Updating From Push
        this.leanPlanningAlertsService.updateSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error(
            'Failed to change route itinerary @planningRoute@onRouteOrderChange',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
        this.bringozLoaderService.off();
      })
  }

  onRemoveTaskFromRoute(tasks: TaskModel[], routeId: string, event?) {
    this._removeTasksFromRoute(tasks, routeId, event)
  }

  onResourcesDropListIdsChange(panel: RoutePanelModel, ids: string[]) {
    let resourcesDropListIdsCopy = angular.copy(this.resourcesDropListIds);
    resourcesDropListIdsCopy = resourcesDropListIdsCopy.filter(
      id => !id.startsWith(panel.id + '-')
    );
    this.resourcesDropListIds = _.uniq(_.concat(resourcesDropListIdsCopy, ids));
  }

  onRoutesDropListIdsChange(panel: RoutePanelModel, ids: string[]) {
    let routesDropListIdsCopy = angular.copy(this.routesDropListIds);
    routesDropListIdsCopy = routesDropListIdsCopy.filter(
      id => !id.startsWith(panel.id + '-')
    );
    this.routesDropListIds = _.uniq(_.concat(routesDropListIdsCopy, ids));
  }

  onAddServicesToResource(resource: ResourceAllocationTimeWindowExtModel, serviceIds: string[]) {
    this._addServicesToResource(resource, serviceIds);
  }

  onChangeResourceSequence(routeGroupId: string, orderedRouteIds: string[]) {
    this._changeResourceSequence(routeGroupId, orderedRouteIds);
  }

  onUpdateRouteResource(routeId: string, resource: ResourceAllocationTimeWindowExtModel) {
    // Here the updateExistingRouteResource is always true if there are at least one route
    // since you cannot drop a route onto a resource that doesn't allow retrips
    const queries: ChangeRouteResourceQueryModelModel = {
      updateExistingRouteResource: (!!resource.routes?.length && this.splitService.getUpdateExistingRouteResourceDefault()),
      updateRouteServicesTimeWindows: this.splitService.getUpdateRouteServicesTimeWindowsDefault(),
    }
    this._updateRouteResource(routeId, resource, queries);
  }


  // ******************************
  //        Private methods
  // ******************************

  private updateViewSettings(settings: RoutesPanelsSettingsModel) {
    this.viewSettings.settings = settings;
    if (this.viewSettings?.id) {
      const viewTableSettingsCopy = {...this.viewSettings, settings: settings};
      viewTableSettingsCopy.holderType = ViewSettingsHolderType.User;

      this.viewSettingsService.updateByUser(this.viewSettings.id, viewTableSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          // Keep the local settings: a slower response to an earlier save would roll back newer changes
          this.viewSettings = {...viewSettingsTable, settings: this.viewSettings.settings};
        })

    } else if (this.viewSettingsCreation) {
      // A create is in flight: creating again would duplicate the record, so update it once it exists
      this.hasPendingViewSettingsUpdate = true;
    } else {
      const viewTableSettings = {
        pageName: 'routes',
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.ViewTable,
        settings: settings
      }
      this.viewSettingsCreation = this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          // Keep the local settings: a slower response to an earlier save would roll back newer changes
          this.viewSettings = {...viewSettingsTable, settings: this.viewSettings.settings};
        })
        .finally(() => {
          this.viewSettingsCreation = null;
          // One update carries every save made during the create, since they all mutate this.viewSettings.settings
          if (this.hasPendingViewSettingsUpdate) {
            this.hasPendingViewSettingsUpdate = false;
            this.updateViewSettings(this.viewSettings.settings);
          }
        });

    }
  }

  private _updateRoute(route) {
    this.routesService.updateRoute(route)
      .then((res) => {
        this.resetSelection();
      })
  }

  private _updateRouteMetaData(routeId: string, metaDataPayload: { key: string, value: string }[], route) {
    return this.routesService.updateRouteMetaData(routeId, metaDataPayload)
      .then((updatedRoute: any) => {
        const metaData = updatedRoute?.metaData || this._mergeRouteMetaData(route.metaData, metaDataPayload);

        route.metaData = metaData;
        if (updatedRoute?.updatedTime) {
          route.updatedTime = updatedRoute.updatedTime;
        }
        if (updatedRoute?.updatedAt) {
          route.updatedAt = updatedRoute.updatedAt;
        }

        this.routesFacadeService.emitRouteMetaDataUpdated({
          id: routeId,
          metaData: metaData,
          updatedTime: route.updatedTime,
          updatedAt: route.updatedAt
        });

        return updatedRoute || route;
      });
  }

  private _mergeRouteMetaData(existingMetaData: { key: string, value: string }[], metaDataPayload: { key: string, value: string }[]) {
    const metaDataCopy: { key: string, value: string }[] = angular.copy(existingMetaData) || [];

    _.forEach(metaDataPayload, (item) => {
      const metaDataIndex = _.findIndex(metaDataCopy, (m: { key: string, value: string }) => {
        return m.key === item.key;
      });

      if (metaDataIndex > -1) {
        metaDataCopy[metaDataIndex] = item;
      } else {
        metaDataCopy.push(item);
      }
    });

    return metaDataCopy;
  }

  private _updateInternalTask(task, route) {
    this.tasksService.updateInternalTask(task);
  }

  private _updateRouteName(routeId: string, updatedRouteName: string) {
    const payload: EditDispatchedRouteNameRequestModel = {
      routeName: updatedRouteName
    }

    this.routesService.updateRoutesName(payload, routeId).then((updatedRoute: any) => {
      const routes = updatedRoute
    });
  }


  // private _addExpandedRoutes(routes: RouteModel[]) {
  //   this._setExpandedRoutes(routes);
  // }

  // private _getExpandedRoutes(routeIds) {
  //   this.routesService.getRoutes(routeIds, undefined, false)
  //     .then((expandedRoutes: any) => {
  //       const updatedExpendedRoutes = _.filter(this.expandedRoutes, (r) => {
  //         return !_.includes(routeIds, r.rid);
  //       });
  //       this.expandedRoutes = updatedExpendedRoutes.concat(expandedRoutes);
  //       this.routesFacadeService.setMany(expandedRoutes);
  //
  //       const tasksToSet = _.flatMap(expandedRoutes, 'taskListExt');
  //       this.tasksFacadeService.setMany(tasksToSet);
  //     })
  // }

  private _setExpandedRoutes(routes: RouteModel[]) {
    const routeIds = _.map(routes, 'id');

    const updatedExpendedRoutes = _.filter(this.expandedRoutes, (r) => {
      return !_.includes(routeIds, r.rid);
    });
    this.expandedRoutes = updatedExpendedRoutes.concat(routes);
    this.routesFacadeService.setMany(routes);
  }

  private _removeExpandedRoutes(routeIds: string[]) {
    this.expandedRoutes = _.filter(this.expandedRoutes, function (expendedRoute) {
      return !_.includes(routeIds, expendedRoute.rid)
    });
    this.routesFacadeService.removeByIds(routeIds);
    this.selectedServiceIds = [];
  }

  private _removeTasksFromRoute(tasks: TaskModel[], routeId: string, event?) {
    let loading = false;
    const text = 'Are you sure you want to remove from route?';
    const header = this.$filter('translate')('Remove Deliveries From Route');
    const actions = this.commonsService.getConfirmActions(['Reset Services']);
    this.confirmDialogService.confirmWithActions(header + ' ' + routeId, text, actions, event)
      .then((actionsResponse) => {
        loading = true;
        this.bringozLoaderService.on();
        let serviceIds = [];
        _.forEach(tasks, (task: TaskModel) => {
          if (task.serviceId) {
            serviceIds.push(task.serviceId)
          } else {
            serviceIds = serviceIds.concat(task.bundleServiceIdList)
          }
        });
        return this.leanPlanningRequestsService.removeDeliveryFromRoute(serviceIds, routeId, actionsResponse[0].enabled);
      })
      .then((route) => {
        this.leanPlanningAlertsService.removeTaskSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.removeTaskError();
          this.$log.error('Failed to remove task from route @planningRoute@onRemoveTaskFromRoute', error);
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      })
  }

  //Todo Take the panel filters for exclude mode

  private _resetRoutes(panel: RoutePanelModel, ids?: string[], excludeMode?: boolean) {
    this.loading = true;
    this.routeRequestsService.resetRoutes(
      excludeMode ? [] : ids,
      panel.routesFilters.bringozFilters.branchIds,
      excludeMode ? ids : [],
      panel.routesFilters.range.dateStart,
      panel.routesFilters.range.dateEnd,
      undefined,
      panel.routesFilters.bringozFilters.agentSkills,
      panel.routesFilters.queryString,
      panel.routesFilters.bringozFilters.serviceAreaIds,
      (panel.routesFilters.routesStatus ? [panel.routesFilters.routesStatus] : undefined),
      panel.routesFilters.bringozFilters.resourceIds,
      panel.routesFilters.bringozFilters.tags,
      panel.routesFilters.bringozFilters.depotIds,
      panel.routesFilters.bringozFilters.resourceTags,
      panel.routesFilters.bringozFilters.vehicleTypeIds,
      panel.routesFilters.bringozFilters.relationTypes,
    )
      .then((updatedRoutes) => {
        if (updatedRoutes.length > 1) {
          this.leanPlanningAlertsService.resetManySuccess();
        } else {
          this.leanPlanningAlertsService.resetSuccess();
        }
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.resetManyError();
          this.$log.error('Failed to reset routes @planningRoutes@onResetRoutes',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  //Todo Take the panel filters for exclude mode

  _deleteRoutes(panel: RoutePanelModel, ids, excludeMode) {
    this.loading = true;
    this.routeRequestsService.deleteRoutes(
      excludeMode ? [] : ids,
      panel.routesFilters.bringozFilters.branchIds,
      excludeMode ? ids : [],
      panel.routesFilters.range.dateStart,
      panel.routesFilters.range.dateEnd,
      panel.routesFilters.bringozFilters.agentSkills,
      panel.routesFilters.queryString,
      panel.routesFilters.bringozFilters.serviceAreaIds,
      (panel.routesFilters.routesStatus ? [panel.routesFilters.routesStatus] : undefined),
      panel.routesFilters.bringozFilters.resourceIds,
      panel.routesFilters.bringozFilters.tags,
      panel.routesFilters.bringozFilters.depotIds,
      panel.routesFilters.bringozFilters.resourceTags,
      panel.routesFilters.bringozFilters.vehicleTypeIds,
      panel.routesFilters.bringozFilters.relationTypes
    )
      .then((deletedRoutes) => {
        if (deletedRoutes.length > 1) {
          this.leanPlanningAlertsService.deleteManySuccess();
        } else {
          this.leanPlanningAlertsService.deleteOneSuccess();
        }
        this.resetSelection(ids);
      })
      .catch((error) => {
        this.leanPlanningAlertsService.deleteManyError();
        this.$log.error('Failed to delete routes @planningRoutes@onDeleteRoutes', error);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onGroupedTaskToggle(id: string) {
    const nextUngroupedRouteIds = new Set(this.ungroupedRouteIds);

    if (nextUngroupedRouteIds.has(id)) {
      nextUngroupedRouteIds.delete(id);
    } else {
      nextUngroupedRouteIds.add(id);
    }

    this.ungroupedRouteIds = nextUngroupedRouteIds;
  }

  splitServiceByPackages(item: Service | TaskModel, event: MouseEvent) {
    const panel = this.panelService.open(ServiceSplitByPackagesComponent, event, { item }, {
      position: {
        originX: 'center',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      },
      height: 400,
      width: 550
    });

    if (this._splitPackagesPopupSubscription) {
      this._splitPackagesPopupSubscription.unsubscribe();
    }

    this._splitPackagesPopupSubscription = panel.instance.onSplitServiceByPackages.subscribe((payload) => {
      const request: SplitServicesPayloadModel = {
        newServices: [{
            packages: payload.packages.map(pkg => ({
              id: pkg.id,
              barcode: pkg.barcode || '',
              moveCount: pkg.count,
            })),
            optimize: false
          }]
      };
      const id = 'serviceId' in item ? item.serviceId : item.id;

      this.servicesService.movePackages(id, request).then((response: ServicesMovePackagesResponseModel) => {
        switch (payload.assign) {
          case SplitAssignmentType.ROUTE:
            this.deliveriesDialogService.assignToRoute(event, response.createdServiceIds).then(result => {
              if (result.routeId && result.serviceIds.length > 0) {
                this.deliveriesAlertsService.movePackagesAndAssignSuccess(result.routeId, result.serviceIds[0]).then(action => {
                  if (action) {
                    this.$state.go('planning.route', { id: result.routeId });
                  }
                });
              }
            });
            break;
          case SplitAssignmentType.RESOURCE:
            this.deliveriesDialogService.assignToResourceAllocation(event, response.createdServiceIds, true).then(result => {
              if (result.routeId && result.serviceIds.length > 0) {
                this.deliveriesAlertsService.movePackagesAndAssignSuccess(result.routeId, result.serviceIds[0]).then(action => {
                  if (action) {
                    this.$state.go('planning.route', { id: result.routeId });
                  }
                });
              }
            });
            break;
          default:
            break;
        }
      });
    });
  }

  //Todo Take the panel filters for exclude mode

  private _updateBranchesRoutes(panel: RoutePanelModel, ids, excludeMode, branchIdsPayload) {
    this.loading = true;
    this.routeRequestsService.updateBranch(
        excludeMode ? [] : ids,
      branchIdsPayload,
        panel.routesFilters.bringozFilters.branchIds,
        excludeMode ? ids : [],
        panel.routesFilters.range.dateStart,
      panel.routesFilters.range.dateEnd,
      panel.routesFilters.bringozFilters.agentSkills,
      panel.routesFilters.queryString,
      panel.routesFilters.bringozFilters.serviceAreaIds,
      (panel.routesFilters.routesStatus ? [panel.routesFilters.routesStatus] : undefined),
      panel.routesFilters.bringozFilters.resourceIds,
      panel.routesFilters.bringozFilters.tags,
      panel.routesFilters.bringozFilters.depotIds,
      panel.routesFilters.bringozFilters.resourceTags,
      panel.routesFilters.bringozFilters.vehicleTypeIds,
      panel.routesFilters.bringozFilters.relationTypes
    )
      .then((updatedRoutes) => {
        this.leanPlanningAlertsService.updateSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error('Failed to update routes @planningRoutes@_updateBranchesRoutes',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _addServicesToResource(resource: ResourceAllocationTimeWindowExtModel, serviceIds: string[]) {
    const createRoutePayload = {
      planningResource: {
        allocationInstanceId: resource.id,
        allocationTimeWindowId: resource.id,
        resourceAllocationId: resource.resourceAllocationId, // Not sure needed
        supplyResourceSource: "Allocation"
      },
      serviceIdList: serviceIds
    }
    this.leanPlanningService.createRoute(createRoutePayload)
    // this.servicesService.addServicesToResource(serviceIds, false, resource.id, resource.resourceAllocationId, 'Allocation', false)
  }

  private _changeResourceSequence(routeGroupId: string, orderedRouteIds: string[]) {
    this.leanPlanningService.editGroupSequence(routeGroupId, orderedRouteIds);
  }

  private _updateRouteResource(routeId: string, allocation: ResourceAllocationTimeWindowExtModel, queries?: ChangeRouteResourceQueryModelModel) {
    this.leanPlanningService.recreateRoute(routeId, allocation.resourceAllocationId, allocation.id, "Allocation", allocation.id, queries)
      .catch((error) => {
        this.leanPlanningAlertsService.updateResourceRouteError();
        this.$log.error('Failed to update route resource @routesView@_updateRouteResource', error);
      });
  }

  private _updateBranchesRoute(id, branchIdsPayload) {
    this.loading = true;
    this.routeRequestsService.updateBranch([id], branchIdsPayload)
      .then((updatedRoutes) => {
        this.leanPlanningAlertsService.updateSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error('Failed to update routes @planningRoutes@_updateBranchesRoutes', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _assignRoutes(ids: string[], agentId: string, assignServices?: boolean) {
    this.leanPlanningService.assignRoutesToAgent(ids, agentId, assignServices)
      .then((res) => {
        this.resetSelection();
      })
  }

  private _assignAssistant(routeId: string, updatedAssistants: string[]) {
    this.routesService.assignAssistant(routeId, updatedAssistants)
      .then((updatedRoute) => {
        this.resetSelection();
      })
  }

  private _handleUnpackedServices(route, services, event?) {
    this.leanPlanningDialogService.handleUnpackedServices(services, event)
      .then((serviceIdsToRemove) => {
        this.loading = true;
        return this.leanPlanningRequestsService.removeDeliveryFromRoute(serviceIdsToRemove,
          route.rid)
      })
      .then(() => {
        this.leanPlanningAlertsService.removeUnpackedSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.removeUnpackedError();
          this.$log.error(
            'Failed to remove unpacked deliveries @planningRoutes@onHandleUnpackedDeliveries',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private _initPushesTimer() {
    this._destroyPushesTimer();

    this.pushesTimeoutRef = this.$timeout(() => {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;

      this.commonsDialogService.stillThereConfirm()
        .then((continueSession) => {
          if (continueSession) {
            this._initPushesTimer();
          }
        })
    }, (this.maxUserIdleTimeMinutes * 60000));
  }

  private _destroyPushesTimer() {
    if (this.pushesTimeoutRef) {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;
    }
  }

  private _getHasDefaultViewSettingsChanged(settings: RoutesPanelsSettingsModel): boolean {
    const defaultSettings = this._getDefaultViewSettings();
    return _.size(defaultSettings.services.columns) !== _.size(settings.viewSettings?.services.columns) ||
      _.size(defaultSettings.services.load) !== _.size(settings.viewSettings?.services?.load) ||
      _.size(defaultSettings.routes.columns) !== _.size(settings.viewSettings?.routes?.columns) ||
      _.size(defaultSettings.routes.metadata) !== _.size(settings.viewSettings?.routes?.metadata) ||
      _.size(defaultSettings.routes.load) !== _.size(settings.viewSettings?.routes?.load) ||
      _.size(defaultSettings.routes.capacity) !== _.size(settings.viewSettings?.routes?.capacity) ||
      _.size(defaultSettings.route.columns) !== _.size(settings.viewSettings?.route?.columns) ||
      _.size(defaultSettings.route.load) !== _.size(settings.viewSettings?.route?.load) ||
      _.size(defaultSettings.route.capacity) !== _.size(settings.viewSettings?.route.capacity) ||
      _.size(defaultSettings.resources.columns) !== _.size(settings.viewSettings?.resources?.columns) ||
      _.size(defaultSettings.resources.load) !== _.size(settings.viewSettings?.resources?.load) ||
      _.size(defaultSettings.resources.capacity) !== _.size(settings.viewSettings?.resources?.capacity);

  }

  private _getDefaultViewSettings(): RoutesViewSettingsModel {
    const viewSettings = this.routesConstants.defaultViewSettings;
    viewSettings.routes.metadata = this.splitService.getRoutesMetadataSettings();

    return viewSettings;
  }
}

angular
  .module('bringoz.admin.routes')
  .component('routesView', {
    bindings: {
      viewSettings: '<?',
      project: '<?',
      branchMode: '<?',
      onSelectRouteResource: '&'
    },
    template: require('./routes-view.html').default,
    controller: RoutesViewComponent
  });
